// @flow
export const selector = (state: any) => state.login;